import { getReportRouteSegment } from '@/lib/reports/status';
import { Navigate, useOutletContext } from 'react-router-dom';
import type { ReportContextType } from './layout';

export const ReportRedirect = () => {
  const { report } = useOutletContext<ReportContextType>();
  return <Navigate to={getReportRouteSegment(report.status)} replace />;
};
